<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <page-loading v-if="!team"></page-loading>
            <template v-else>
                <team-billing-details
                    v-show="hash === 'billing-details' || !hash"
                    :team="team"
                    :isAdminOrOwner="isAdminOrOwner"
                />

                <team-proforma-invoices
                    v-if="FEATURES.new_billing_implementation && team.status !== 'closed'"
                    v-show="hash === 'proforma-invoices'"
                    :teamId="team.id"
                    :paymentTermsDays="team.payment_terms_days"
                />

                <team-plan-information
                    v-if="!FEATURES.new_billing_implementation"
                    v-show="hash === 'plan-information'"
                    :team="team"
                    :team-plan="props.teamPlan"
                    :team-message-balance="props.teamMessageBalance"
                    :team-sum-balance-amount="props.teamSumBalanceAmount"
                    :is-admin-or-owner="isAdminOrOwner"
                />

                <team-historical-invoices v-show="hash === 'historical-invoices'" :team-id="team.id" />
            </template>
        </div>
    </page-container>
</template>

<script setup>
import TeamBillingDetails from './TeamBillingDetails.vue';
import TeamProformaInvoices from './TeamProformaInvoices.vue';
import TeamHistoricalInvoices from './TeamHistoricalInvoices.vue';
import TeamPlanInformation from './TeamPlanInformation.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { ref, onMounted, inject } from 'vue';
import axios from '~/services/axios';
import { useSettingsHash } from '~/composables/useSettingsHash';

const props = defineProps({
    teamPlan: {
        type: Object,
        default: null,
    },
    teamMessageBalance: {
        type: Number,
        default: 0,
    },
    teamSumBalanceAmount: {
        type: Number,
        default: 0,
    },
});

const FEATURES = inject('FEATURES');

const { hash, content } = useSettingsHash();

const team = ref(null);

const teamId = Spark.state.currentTeam.id;
const isAdminOrOwner = Spark.isAdminOrOwner;

const getTeam = () => {
    axios.get(`/settings/teams/json/${teamId}`).then((response) => {
        team.value = response.data;
    });
};

onMounted(() => {
    getTeam();
});

Bus.$on('updateTeam', () => {
    getTeam();
});
</script>
